import React, { useCallback } from 'react';
import { StyleSheet } from 'react-native';
import {
  Colors,
  Flex,
  IconChevronRight,
  Typography,
} from '@banhala/ui-kit';
import Svg, { Defs, LinearGradient, Path, Rect, Stop } from 'react-native-svg';
import { useNavigator } from 'shared/src/utils';
import { useLogClickBeautyDepartment } from './hooks/useLogClickBeautyDepartment';

const BANNER_HEIGHT = 50;
const LOGO_WIDTH = 55;
const LOGO_HEIGHT = 15;
const BEAUTY_LOGO_PATH =
  'M50.111,8.371L51.927,3.244H54.551L49.771,15H47.289L48.793,11.317L45.517,3.244H48.311L50.111,8.371ZM32.877,7.62C32.877,8.253 33,8.739 33.246,9.079C33.501,9.41 33.865,9.575 34.338,9.575C34.829,9.575 35.217,9.391 35.501,9.022C35.784,8.654 35.926,8.149 35.926,7.507V3.244H38.45V11.544H35.926V10.694C35.406,11.393 34.631,11.742 33.601,11.742C32.958,11.742 32.39,11.591 31.898,11.289C31.407,10.996 31.024,10.572 30.75,10.015C30.485,9.458 30.353,8.801 30.353,8.046V3.244H32.877V7.62ZM14.696,3.044C15.528,3.044 16.271,3.233 16.923,3.61C17.585,3.979 18.1,4.493 18.469,5.154C18.837,5.815 19.021,6.562 19.021,7.393C19.021,7.666 19.003,7.936 18.965,8.2H12.881C12.975,8.682 13.184,9.055 13.505,9.319C13.826,9.584 14.224,9.716 14.696,9.716C15.056,9.716 15.372,9.659 15.646,9.546C15.93,9.423 16.125,9.263 16.229,9.064H18.767C18.625,9.593 18.36,10.056 17.973,10.452C17.585,10.858 17.107,11.175 16.54,11.401C15.973,11.628 15.358,11.741 14.696,11.741C13.865,11.741 13.118,11.552 12.456,11.175C11.804,10.807 11.292,10.292 10.924,9.631C10.555,8.97 10.371,8.224 10.371,7.393C10.371,6.562 10.555,5.815 10.924,5.154C11.292,4.493 11.804,3.979 12.456,3.61C13.118,3.233 13.865,3.044 14.696,3.044ZM23.893,3.044C24.961,3.044 25.755,3.394 26.275,4.093V3.242H28.8V11.543H26.275V10.692C25.755,11.391 24.961,11.741 23.893,11.741C23.108,11.741 22.408,11.552 21.794,11.175C21.18,10.807 20.702,10.292 20.361,9.631C20.021,8.97 19.851,8.224 19.851,7.393C19.851,6.562 20.021,5.815 20.361,5.154C20.702,4.493 21.18,3.979 21.794,3.61C22.408,3.233 23.108,3.044 23.893,3.044ZM5.021,0C6.287,0 7.27,0.307 7.97,0.921C8.679,1.535 9.034,2.375 9.034,3.441C9.034,3.866 8.906,4.282 8.65,4.688C8.395,5.085 8.074,5.354 7.687,5.496C8.235,5.676 8.684,6.006 9.034,6.487C9.393,6.959 9.572,7.479 9.572,8.045C9.572,8.753 9.407,9.372 9.076,9.9C8.755,10.429 8.282,10.836 7.658,11.119C7.034,11.402 6.296,11.544 5.445,11.544H0V0H5.021ZM43.572,3.244H45.217V5.411H43.572V11.544H41.048V5.411H39.402V3.244H41.048V0.779H43.572V3.244ZM24.29,5.197C23.694,5.197 23.217,5.405 22.857,5.82C22.498,6.226 22.318,6.75 22.318,7.393C22.318,8.035 22.498,8.563 22.857,8.979C23.217,9.385 23.694,9.588 24.29,9.588C24.904,9.588 25.396,9.384 25.765,8.979C26.133,8.563 26.317,8.035 26.317,7.393C26.317,6.75 26.133,6.226 25.765,5.82C25.396,5.405 24.904,5.197 24.29,5.197ZM2.581,9.349H5.332C5.852,9.349 6.259,9.235 6.552,9.009C6.845,8.782 6.991,8.46 6.991,8.045C6.991,7.63 6.845,7.309 6.552,7.082C6.259,6.855 5.852,6.742 5.332,6.742H2.581V9.349ZM14.696,5.041C14.205,5.041 13.803,5.173 13.491,5.438C13.179,5.692 12.971,6.071 12.867,6.571H16.555C16.451,6.071 16.237,5.692 15.916,5.438C15.595,5.173 15.188,5.041 14.696,5.041ZM2.581,4.674H4.907C5.399,4.674 5.776,4.57 6.041,4.362C6.315,4.145 6.453,3.838 6.453,3.441C6.453,3.036 6.315,2.729 6.041,2.521C5.776,2.304 5.399,2.195 4.907,2.195H2.581V4.674Z';

const BeautyLogo = () => (
  <Svg width={LOGO_WIDTH} height={LOGO_HEIGHT} viewBox="0 0 55 15">
    <Path d={BEAUTY_LOGO_PATH} fill="#FFFFFF" />
  </Svg>
);

const GradientBackground = () => (
  <Svg style={StyleSheet.absoluteFill}>
    <Defs>
      <LinearGradient id="beautyBannerBg" x1="0" y1="0" x2="0" y2="1">
        <Stop offset="0" stopColor="#FF717D" />
        <Stop offset="1" stopColor="#FF5770" />
      </LinearGradient>
    </Defs>
    <Rect width="100%" height="100%" fill="url(#beautyBannerBg)" />
  </Svg>
);

export const BeautyBanner = () => {
  const { navigator } = useNavigator();
  const logClickBeautyDepartment = useLogClickBeautyDepartment();

  const handlePress = useCallback(() => {
    logClickBeautyDepartment();
    navigator.moveToScreens('BEAUTY_DEPARTMENT');
  }, [logClickBeautyDepartment, navigator]);

  return (
    <Flex
      height={BANNER_HEIGHT}
      padding={{ horizontal: 16 }}
      justifyContent={'center'}
      onPress={handlePress}
    >
      <GradientBackground />
      <Flex.Row alignItems={'center'} gap={8}>
        <BeautyLogo />
        <Flex
          width={1}
          height={8}
          backgroundColor={'content_always_white'}
          opacity={0.5}
        />
        <Flex.Row alignItems={'center'} gap={2}>
          <Typography type={'body2'} color={'content_always_white'}>
            에이블리로 매일 리즈 갱신
          </Typography>
          <IconChevronRight size={16} fill={Colors.content_always_white} />
        </Flex.Row>
      </Flex.Row>
    </Flex>
  );
};
